import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/Index.vue";
import login from "../views/Login.vue";
import tocnki from "../views/ToCnki.vue";
// import start from "../views/Start.vue";

Vue.use(VueRouter);

/* //解决报错 Navigation cancelled from "/backStage/tenderManage" to "/backStage/subjectPromoteManageDetail" with a new navigation.
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
} */


const routes = [
  {
    path: "/",
    redirect: "/legislateKnowledgeBase"
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/tocnki",
    name: "tocnki",
    component: tocnki
  },
  {
    path: "/index",
    name: "index",
    component: index,
    meta: {
      requireAuth: true,
    }
  },
  {
    path: "/recordReview", //智能审查
    name: "recordReviewAll",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReview.vue"),
    children: [
      {
        path: "/recordReview/reviewTaskManage", //备案审查管理
        name: "reviewTaskManage",
        component: () =>
          import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/reviewTaskManage/reviewTaskManage.vue")
      },
      {
        path: "/recordReview/reviewDetail",//备案审查详情
        name: "reviewDetail",
        component: () =>
          import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReviewDetail/reviewDetail.vue"),
        children: [
          {
            path: "/recordReview/recordReview",//备案审查详情-智能审查
            name: "recordReview",
            component: () =>
              import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReviewDetail/recordReview/recordReview.vue")
          },
          {
            path: "/recordReview/generateReport",//备案审查详情-生成报告
            name: "generateReport",
            component: () =>
              import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReviewDetail/generateReport/generateReport.vue")
          },
          {
            path: "/recordReview/reviewFile",//备案审查详情-审查文件
            name: "reviewFile",
            component: () =>
              import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReviewDetail/reviewFile/reviewFile.vue")
          },
          {
            path: "/recordReview/reviewReport",//备案审查详情-审查报告
            name: "reviewReport",
            component: () =>
              import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReviewDetail/reviewReport/reviewReport.vue")
          },
          {
            path: "/recordReview/reviewOpinion",//备案审查详情-审查意见
            name: "reviewOpinion",
            component: () =>
              import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReviewDetail/reviewOpinion/reviewOpinion.vue")
          },
          {
            path: "/recordReview/reviewHistory",//备案审查详情-审查历史
            name: "reviewHistory",
            component: () =>
              import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/recordReviewDetail/reviewHistory/reviewHistory.vue")
          },
        ]
      },
      {
        path: "/recordReview/reviewReportManage", //备案报告管理
        name: "reviewReportManage",
        component: () =>
          import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/reviewReportManage/reviewReportManage.vue")
      },
      {
        path: "/recordReview/reviewAnalyze", //备案统计分析
        name: "reviewAnalyze",
        component: () =>
          import(/* webpackChunkName: "ImportFunc" */ "../components/recordReview/reviewAnalyze/reviewAnalyze.vue")
      },
    ],
    meta: {
      requireAuth: true //表示这个组件需要登录
    }
  },
  {
    path: "/legislateKnowledgeBase",//立法知识库
    name: "legislateKnowledgeBase",
    // meta: {
    //   requireAuth: true,
    // },
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../components/legislateKnowledgeBase/legislateKnowledgeBase.vue"),

  },
  {
    path: "/refresh",
    name: "refresh",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../components/refresh.vue")
  },
  {
    path: "/cnkiDetail", //知网详情页
    name: "cnkiDetail",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../components/cnkiDetail/cnkiDetail.vue")
  },

  // {
  //   path: "/result",
  //   name: "result",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../views/Result.vue")
  // },
  // {
  //   path: "/detail/:id", //接收params传来的id
  //   name: "detail",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../views/Detail.vue")
  // },
  // {
  //   path: "/upload", 
  //   name: "upload",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/upload.vue")
  // },
  // {
  //   path: "/orgList", 
  //   name: "orgList",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/orgList.vue")
  // },
  // {
  //   path: "/orgResult", 
  //   name: "orgResult",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/orgResult.vue")
  // },
  // {
  //   path: "/parList", 
  //   name: "parList",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/parList.vue")
  // },
  // {
  //   path: "/parResult", 
  //   name: "parResult",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/parResult.vue")
  // },
  // {
  //   path: "/analyze", 
  //   name: "analyze",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/analyze/analyze.vue")
  // },
  // {
  //   path: "/projectBidList", 
  //   name: "projectBidList",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/projectBidList/projectBidList.vue")
  // },
  // {
  //   path: "/projectPromoteList", 
  //   name: "projectPromoteList",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/projectPromoteList/projectPromoteList.vue")
  // },
  // {
  //   path: "/projectConcludeList", 
  //   name: "projectConcludeList",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/projectConcludeList/projectConcludeList.vue")
  // },
  // {
  //   path: "/excellentAchievements", 
  //   name: "excellentAchievements",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/excellentAchievements/excellentAchievements.vue")
  // },
  // {
  //   path: "/dynamicList", //工作动态列表-前
  //   name: "dynamicList",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/dynamicList/dynamicList.vue")
  // },

  // {  //意见反馈-前台
  //   path: "/feedback", 
  //   name: "feedback",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/feedback/feedback.vue")
  // },
  // {
  //   path: "/messageQueryDetail/:id", //接收params传来的id 留言查询详情
  //   name: "messageQueryDetail",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/feedback/messageQueryDetail.vue")
  // },


  // {
  //   path: "/backStage", 
  //   name: "backStage",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/backStage.vue"),
  //     children:[
  //       {
  //         path:"/backStage/panel",
  //         name:"panel",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/panel/panel.vue")
  //       },
  //       {
  //         path:"/backStage/orgManage",
  //         name:"orgManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/orgManage/orgManage.vue")
  //       },
  //       {
  //         path:"/backStage/parManage",
  //         name:"parManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/parManage/parManage.vue")
  //       },
  //       {
  //         path:"/backStage/userManage",
  //         name:"userManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/userManage/userManage.vue")
  //       },
  //       {
  //         path:"/backStage/resultManage",
  //         name:"resultManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/resultManage/resultManage.vue")
  //       },
  //       {
  //         path:"/backStage/resultApprove",
  //         name:"resultApprove",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/resultApprove/resultApprove.vue")
  //       },
  //       {
  //         path:"/backStage/goodSubjectResult",
  //         name:"goodSubjectResult",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/goodSubjectResult/goodSubjectResult.vue")
  //       },
  //       {
  //         path:"/backStage/tenderManage",
  //         name:"tenderManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/tenderManage/tenderManage")
  //       },
  //       {
  //         path:"/backStage/bidManage",
  //         name:"bidManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/bidManage/bidManage.vue")
  //       },

  //       {
  //         path:"/backStage/picNewsManage",//后台-图片工作动态
  //         name:"picNewsManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/dynamic/picNewsManage")
  //       },
  //       {
  //         path:"/backStage/textNewsManage",//后台-文字工作动态
  //         name:"textNewsManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/dynamic/textNewsManage")
  //       },
  //       {
  //         path:"/backStage/departmentManage", //主管部门管理
  //         name:"departmentManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/departmentManage/departmentManage.vue")
  //       },

  //       {
  //         path:"/backStage/feedbackManage", //意见反馈管理-后台
  //         name:"feedbackManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/feedbackManage.vue")
  //       },
  //       // {
  //       //   path:"/backStage/accountApproveList", //账号审批列表
  //       //   name:"accountApprove",
  //       //   component: () =>
  //       //   import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/accountApproveList.vue")
  //       // },
  //       // {
  //       //   path:"/backStage/researcherApproveList", //研究人员认证申请列表
  //       //   name:"researcherApproveList",
  //       //   component: () =>
  //       //   import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/researcherApproveList.vue")
  //       // },
  //       // {
  //       //   path:"/backStage/expertApproveList", //专家认证申请列表
  //       //   name:"expertApproveList",
  //       //   component: () =>
  //       //   import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/expertApproveList.vue")
  //       // },
  //       // {
  //       //   path:"/backStage/basicInformation", //个人账号基本信息
  //       //   name:"basicInformation",
  //       //   component: () =>
  //       //   import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/basicInformation/basicInformation.vue")
  //       // },
  //       // {
  //       //   path:"/backStage/upgradeResearcher", //升级为研究人员-研究人员认证信息
  //       //   name:"upgradeResearcher",
  //       //   component: () =>
  //       //   import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/basicInformation/upgradeResearcher.vue")
  //       // },
  //       // {
  //       //   path:"/backStage/upgradeExpert", //升级为专家-专家认证信息
  //       //   name:"upgradeExpert",
  //       //   component: () =>
  //       //   import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/basicInformation/upgradeExpert.vue")
  //       // },
  //       // {
  //       //   path:"/backStage/basicInformationOrg", //机构信息
  //       //   name:"basicInformationOrg",
  //       //   component: () =>
  //       //   import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/basicInformation/basicInformationOrg.vue")
  //       // },



  //       {
  //         path:"/backStage/expertEvaluate", //课题推进-专家评审
  //         name:"expertEvaluate",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/subjectPromote/expertEvaluate/expertEvaluate.vue"),
  //       },
  //       {
  //         path:"/backStage/expertEvaluateDetail", //专家评审-立项/验收
  //         name:"expertEvaluateDetail",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/subjectPromote/expertEvaluate/expertEvaluateDetail.vue")
  //       },
  //       {
  //         path:"/backStage/subjectPromoteManage",//课题推进管理
  //         name:"subjectPromoteManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/subjectPromote/subjectPromoteManage/subjectPromoteManage.vue"),
  //       },
  //       {
  //         path:"/backStage/subjectPromoteManageDetail",//课题推进管理==详情
  //         name:"subjectPromoteManageDetail",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/subjectPromote/subjectPromoteManage/subjectPromoteManageDetail.vue"),
  //       },
  //       {
  //         path:"/backStage/subjectResearchManage",//课题研究管理
  //         name:"subjectResearchManage",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/subjectPromote/subjectResearchManage/subjectResearchManage.vue"),
  //       },
  //       {
  //         path:"/backStage/subjectResearchManageDetail",//课题研究管理-详情
  //         name:"subjectResearchManageDetail",
  //         component: () =>
  //         import(/* webpackChunkName: "ImportFunc" */ "../components/backStage/subjectPromote/subjectResearchManage/subjectResearchManageDetail.vue"),
  //       },

  //     ],    
  // },
  // 注册
  // {
  //   path: "/register",
  //   name: "register",
  //   component: () =>
  //     import(/* webpackChunkName: "ImportFunc" */ "../views/Register.vue")
  // },

];

const router = new VueRouter({
  // mode:"history", //去除访问地址中# 打包时要注释掉 
  routes
});

//路由不匹配或者路径错误，跳转首页的方法
// router.beforeEach((to,from,next)=>{
//   if(to.matched.length === 0){//匹配前往的路由不存在
//     from.name ? next({
//       name: from.name
//     }) : next('/index'); //判断此跳转路由的来源路由是否存在，存在就跳转到来源路由，否则跳转首页
//   }else{
//     next();//如果匹配到正确跳转
//   }
// });

let v = new Vue();
/** 
 * 提示函数 
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  v.$message({
    message: msg,
    type: "warning",
    duration: 2000
  });
}
//全局监听路由
router.beforeEach((to, from, next) => {
  // console.log(from);
  console.log(to);
  if (to.matched.some(route => route.meta && route.meta.requireAuth)) {
    if (!window.localStorage.getItem("token")) { //没有登录信息跳转到登录页
      if (to.query.token) {
        let queryString = to.fullPath.split('?')[1]
        next(`/tocnki?&pagetype=1&${queryString}`)
        return
      }
      tip("登录后才可以查看！");
      // let {radioTree,treeId} =  to.query //跳转过来携带的id
      // console.log('radioTree=='+ radioTree,'treeId=='+treeId);
      // if(treeId){
      //   next('/legislateKnowledgeBase?radioTree='+ radioTree + '&treeId='+treeId);
      // }else{
      //   next('/legislateKnowledgeBase');
      // }
      next('/login')
    } else {
      next();//如果匹配到正确跳转
    }
  }
  else if (to.matched.length === 0) {//匹配前往的路由不存在
    from.name ? next({
      name: from.name
    }) : next('/legislateKnowledgeBase'); //判断此跳转路由的来源路由是否存在，存在就跳转到来源路由，否则跳转首页
  }
  else {
    next();//如果匹配到正确跳转
  }
});

//避免报错：Avoided redundant navigation to current location: "/index".
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default router;
